import { defineAsyncComponent } from 'vue';

export const TimeOffSettingsPageFrontends = {
	TimeOffSettingsPage: defineAsyncComponent(
		() => import('./components/TimeOffSettingsPage')
	),
};
